import React from 'react';
import SVGUniqueID from 'react-svg-unique-id';

import { colors as Colors } from '../../themes/Colors';

import { SVGComponentProps } from '../type';

const EnrollmentVerificationStepIcon: React.FC<SVGComponentProps> = ({
  width = 20,
  height = 20,
  stroke = Colors['light-red-900'],
  fill = 'none',
  ...props
}) => (
  <SVGUniqueID>
    <svg
      width={width}
      height={height}
      viewBox="0 0 15 15"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5.36979 7.36662L6.70312 8.69995L9.70312 5.69995M4.25897 1.91241C4.79486 1.86965 5.3036 1.65892 5.71277 1.31023C6.66761 0.496525 8.07197 0.496525 9.02681 1.31023C9.43598 1.65892 9.94472 1.86965 10.4806 1.91241C11.7312 2.01221 12.7242 3.00525 12.824 4.2558C12.8668 4.79169 13.0775 5.30043 13.4262 5.7096C14.2399 6.66443 14.2399 8.0688 13.4262 9.02364C13.0775 9.43281 12.8668 9.94155 12.824 10.4774C12.7242 11.728 11.7312 12.721 10.4806 12.8208C9.94472 12.8636 9.43598 13.0743 9.02681 13.423C8.07197 14.2367 6.66761 14.2367 5.71277 13.423C5.3036 13.0743 4.79486 12.8636 4.25897 12.8208C3.00842 12.721 2.01538 11.728 1.91559 10.4774C1.87282 9.94155 1.6621 9.43281 1.3134 9.02364C0.499698 8.0688 0.499698 6.66443 1.3134 5.7096C1.6621 5.30043 1.87282 4.79169 1.91559 4.2558C2.01538 3.00525 3.00842 2.01221 4.25897 1.91241Z"
        stroke="#7F1D1D"
        strokeWidth={1.4}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </SVGUniqueID>
);

export { EnrollmentVerificationStepIcon };
